import React from "react";
import { Badge, Button, Checkbox, Group, Menu, Text } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { selectUniqueMcbimBuildingsOnSpaces } from "../McBim/httpMcBimSelectors";
import {
  selectRoomNumberingSelectedBuildings,
  setSelectedBuildings,
} from "./roomNumberingSlice";

export const RoomNumberingBuildingsSelector: React.FC = () => {
  const dispatch = useAppDispatch();
  const buildings = useAppSelector(selectUniqueMcbimBuildingsOnSpaces);
  const selectedBuildings = useAppSelector(selectRoomNumberingSelectedBuildings);

  const selectedSet = new Set(selectedBuildings);

  const handleToggleBuilding = (building: string) => {
    const nextBuildings = selectedSet.has(building)
      ? selectedBuildings.filter((selectedBuilding) => selectedBuilding !== building)
      : [...selectedBuildings, building];

    dispatch(setSelectedBuildings(nextBuildings));
  };

  const buttonLabel =
    selectedBuildings.length === 0
      ? "Bygninger"
      : selectedBuildings.length === 1
        ? selectedBuildings[0]
        : "Bygninger";

  return (
    <Menu withinPortal position="bottom-start" shadow="md" width={260} closeOnItemClick={false}>
      <Menu.Target>
        <Button size="sm" variant="light" disabled={buildings.length === 0}>
          <Group gap={8} wrap="nowrap">
            <Text size="sm" truncate maw={160}>
              {buttonLabel}
            </Text>
            {selectedBuildings.length > 0 && (
              <Badge size="xs" variant="filled">
                {selectedBuildings.length}
              </Badge>
            )}
          </Group>
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>Bygninger</Menu.Label>
        {buildings.map((building) => (
          <Menu.Item key={building} onClick={() => handleToggleBuilding(building)}>
            <Checkbox
              checked={selectedSet.has(building)}
              label={building}
              readOnly
            />
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};
